module.exports = __webpack_public_path__ + "static/media/csl-seqirus.ff4e49da.png";